import React from 'react'
import { tokens } from '../../../styles/desertFloraTheme'

const AreasPanel = ({ projectService }) => {
  const areas = projectService?.areas || []

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <div style={{
          fontFamily: tokens.fontMono, fontSize: 10.5, fontWeight: 600,
          letterSpacing: '.12em', textTransform: 'uppercase', color: tokens.ink3
        }}>
          Areas in this service
        </div>
        <span style={{ fontSize: 11, color: tokens.primary, cursor: 'pointer' }}>
          manage
        </span>
      </div>

      {areas.length === 0 ? (
        <div style={{ fontSize: 12, color: tokens.ink4, fontStyle: 'italic' }}>
          No areas — use areas to split by zone or phase
        </div>
      ) : (
        areas.map((area, idx) => (
          <div
            key={area._id || idx}
            style={{
              display: 'flex', justifyContent: 'space-between',
              padding: '6px 0',
              borderBottom: idx < areas.length - 1 ? `1px dashed ${tokens.line}` : 'none'
            }}
          >
            <span style={{ fontSize: 12, color: tokens.ink2 }}>
              {area.label || `Area ${idx + 1}`}
            </span>
            <span style={{ fontFamily: tokens.fontMono, fontSize: 12, color: tokens.ink }}>
              {area.qty != null ? area.qty : '—'}{area.unit ? ` ${area.unit}` : ''}
            </span>
          </div>
        ))
      )}
    </div>
  )
}

export default AreasPanel
